// Auto-generated from Figma tokens via Style-Dictionary - Do not edit manually
// Generated on: 2025-06-04T01:13:37.581Z

export const lightTheme = {
  color: {
    surface: {
      0: '#ffffff',
      1: '#f7f7f5',
      2: '#e5e4e3',
      3: '#d9d7d4',
      4: '#cbc9c7',
      5: '#b7b5b1',
      '0--halftone': '#ffffff',
      '1--halftone': '#f7f7f5',
      '2-halftone': '#e5e4e3',
      '3-halftone': '#d9d7d4',
      '4-halftone': '#cbc9c7',
      cool: {
        1: '#ffffff',
        2: '#d6dcdd',
      },
    },
    grid: {
      base: '#ffffff',
      stripe: '#f7f7f7',
      hover: '#dcf3f3',
      select: '#ebf1f1',
      'select-inherited': '#f7fafa',
      'select-inherited-stripe': '#ecf2f2',
    },
    focus: {
      1: '#155b68',
      2: '#3c6a73',
      3: '#7199a1',
      4: '#8fb8c0',
      5: '#c3dbe0',
      6: '#f0f6f7',
    },
    brand: {
      'brand-bright-blue': '#a7eef9',
      'brand-bright-green': '#7affa2',
      'brad-dark-teal': '#002c31',
    },
    dataVis: {
      qualitative: {
        'yellow-1': '#ffe484',
        'yellow-2': '#e8c23a',
        'yellow-3': '#8d6f05',
        'orange-1': '#ffc46a',
        'orange-2': '#e89f30',
        'orange-3': '#ac6a05',
        'lime-1': '#e5ee7e',
        'lime-2': '#b7c142',
        'lime-3': '#818c09',
        'moss-1': '#cdf0b7',
        'moss-2': '#80c456',
        'moss-3': '#498524',
        'teal-1': '#b1f6d9',
        'teal-2': '#5bcb9c',
        'teal-3': '#0c7d4e',
        'blue-1': '#bddef3',
        'blue-2': '#5ba0cb',
        'blue-3': '#0d5c8e',
        'violet-1': '#9e97ed',
        'violet-2': '#645bcb',
        'violet-3': '#46408a',
        'mauve-1': '#d397e8',
        'mauve-2': '#ae5bcb',
        'mauve-3': '#762f8f',
        'magenta-1': '#e9a1bb',
        'magenta-2': '#cb5b83',
        'magenta-3': '#8c2f50',
      },
      alert: {
        'limit-1': '#ffb1b1',
        'limit-2': '#ef3e3e',
        'anomaly-1': '#d7faff',
        'anomaly-2': '#afffde',
        'anomaly-3': '#31f1a4',
        'limit-1-halftone': '#ffb1b1',
        'limit-2-halftone': '#ef3e3e',
      },
      core: {
        'critical-2': '#c01212',
        'critical-1': '#873e3e',
        'critical-1-halftone': '#871b1b',
        'critical-2-halftone': '#c00000',
        'data-emphasis': '#000000',
        'data-primary': '#1e1e1e',
        'data-secondary': '#737373',
        'data-tertiary': '#a6a6a6',
        'surface-1': '#f7f7f5',
        'surface-0': '#ffffff',
        'surface-0-halftone-75%': '#ffffff',
        'surface-1-halftone-75%': '#f7f7f5',
        'data-tertiary-halftone': '#a6a6a6',
        'surface-1-halftone-0%': '#f7f7f5',
        'surface-0-halftone-0%': '#ffffff',
      },
    },
    text: {
      core: {
        '-primary': '#1e1e1e',
        '-emphasis': '#000000',
        '-tertiary': '#a6a6a6',
        '-secondary': '#737373',
        '-link': '#155b68',
        'on-dark-primary': '#ffffff',
        'on-dark-secondary': '#d9d9d9',
        'on-light-primary': '#1e1e1e',
        'on-light-secondary': '#737373',
      },
    },
    neutral: {
      grey: {
        opaque: {
          'k-100': '#ffffff',
          'k-97': '#f7f7f7',
          'k-95': '#f2f2f2',
          'k-90': '#e6e6e6',
          'k-85': '#d9d9d9',
          'k-80': '#cccccc',
          'k-65': '#a6a6a6',
          'k-55': '#8c8c8c',
          'k-40': '#666666',
          'k-30': '#333333',
          'k-20': '#333333',
          'k-15': '#262626',
          'k-12': '#1f1f1f',
          'k-10': '#1a1a1a',
          'k-8': '#141414',
          'k-5': '#0d0d0d',
          'k-3': '#080808',
          'k-0': '#000000',
        },
        transparent: {
          'k-50%': '#000000',
          'k-20%': '#000000',
          'k-15%': '#000000',
          'k-10%': '#000000',
          'k-75%': '#000000',
        },
      },
    },
    control: {
      button: {
        primary: '#002c31',
        secondary: '#f9f9f9',
        'primary-hover': '#3c6a73',
        'secondary-hover': '#dbf3f3',
      },
      input: {
        neutral: '#f2f2f2',
      },
    },
    lighting: {
      'deboss-shadow': '#000000',
      'ai-teal': '#7bdcc1',
      'ai-purple': '#8b57e3',
      'ai-teal-halftone': '#7bdcc1',
      'ai-purple-halftone': '#8b57e3',
      'action-teal': '#0097b4',
      'highlight-1': '#ffffff',
      'shadow-2': '#000000',
      'shadow-3': '#000000',
      'shadow-1': '#000000',
    },
  },
  size: {
    spacing: {
      small: '4px',
      medium: '8px',
      large: '16px',
      xs: '2px',
      xl: '24px',
      xxl: '32px',
      xxxl: '40px',
      xxxxl: '48px',
    },
    radius: {
      'radius-xs': '2px',
      'radius-small': '4px',
      'radius-medium': '8px',
      'radius-large': '12px',
    },
  },
};
